import { render } from "./PrintDataBlock.vue?vue&type=template&id=05117251&scoped=true"
import script from "./PrintDataBlock.vue?vue&type=script&lang=js"
export * from "./PrintDataBlock.vue?vue&type=script&lang=js"

import "./PrintDataBlock.vue?vue&type=style&index=0&id=05117251&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05117251"]])

export default __exports__